// extracted by mini-css-extract-plugin
export var container = "_nx-0";
export var dotAnimation = "_nx-2";
export var dotsLoading = "_nx-1";